import { MutableRefObject, useLayoutEffect } from 'react';
import { useToggle } from './useToggle';

export const useIsOverflowing = (
    ref: MutableRefObject<HTMLElement | undefined>,
    callback?: (isOverflowing: boolean) => void
) => {
    const [isOverflowing, setIsOverflowing] = useToggle(undefined);

    useLayoutEffect(() => {
        const { current } = ref;

        const trigger = () => {
            if (!current) return;
            const hasOverflow = current.scrollWidth > current.clientWidth;

            setIsOverflowing(hasOverflow);

            if (callback) callback(hasOverflow);
        };

        trigger();
        // only check on initial render
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return isOverflowing;
};
